import { faArrowLeft } from "@fortawesome/pro-light-svg-icons/faArrowLeft";
import { faArrowRight } from "@fortawesome/pro-light-svg-icons/faArrowRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useUtilTranslations from "../../../hooks/useUtilTranslations";
import { calculatorActions } from "../../../redux/co2calculatorSlice";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import Button from "../../Button/Button";
import styles from "./QuestionNavigator.module.scss";

type QuestionNavigatorProps = {
  onNavigate?: () => void;
};

function QuestionNavigator({ onNavigate }: QuestionNavigatorProps) {
  const tUtil = useUtilTranslations();
  const state = useAppSelector((state) => state.calculator);
  const dispatch = useAppDispatch();

  const nextQuestion = () => {
    const p = dispatch(calculatorActions.nextQuestion());
    console.log(p);
    onNavigate?.();
  };

  const previousQuestion = () => {
    dispatch(calculatorActions.previousQuestion());
    onNavigate?.();
  };

  return (
    <div className={styles.navigator}>
      <div>
        <Button
          disabled={!state.currentQuestion?.previousQuestionId}
          onClick={previousQuestion}
          className={styles.prev}
        >
          <FontAwesomeIcon
            size="lg"
            className={styles.icon}
            icon={faArrowLeft}
          />
          {tUtil("action.previous")}
        </Button>
      </div>
      <div className={styles.pages}>
        {state.session && (
          <>
            <span>{state.session.currentQuestionNumber}</span>
            {/*<span>{state.currentQuestion?.sortOrder}</span>*/}
            <span>/</span>
            <span>
              {state.session.questionCount -
                ((state.session.skippedQuestionIds as string[]) || []).length}
            </span>
          </>
        )}
      </div>
      <div>
        <Button
          color="green"
          disabled={!state.nextQuestionId}
          onClick={nextQuestion}
          className={styles.next}
        >
          {tUtil("action.next")}
          <FontAwesomeIcon
            size="lg"
            className={styles.icon}
            icon={faArrowRight}
          />
        </Button>
      </div>
    </div>
  );
}

export default QuestionNavigator;
